import React from "react";
import Loader from "./Loader";

const LoaderWithContainer: React.FC = () => {
  return (
    <div className="global-container">
      <Loader />
    </div>
  );
};

export default LoaderWithContainer;
